import React, {Component} from 'react';
import {connect} from 'react-redux';

class StackCombinationsTotalMinExposure extends Component {
    getClassName(value) {
        return Number(value) > 100 ? 'text-dark-red' : '';
    }
    render() {
        const {stacking} = this.props;
        const value = stacking.getTotalMinExposureOfCheckedStackCombinations();

        return <strong className={this.getClassName(value)}>Total min exp: {value}%</strong>;
    }
}

function mapStatesToProps(state) {
    const {nhlTeamStacking} = state;

    return {
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(StackCombinationsTotalMinExposure);
